/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const closeCircleFilled = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24">
		<Path d="M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm5 11l-3-3 3-3-2-2-3 3-3-3-2 2 3 3-3 3 2 2 3-3 3 3z" />
	</SVG>
);

export default closeCircleFilled;
